import { permitsPathSegment } from './landingDepartmentMerge';
/**
 * Match agency `DEPARTMENT` column (`departmentKey`) to a department tile from the same Flow grid data
 * (`recordId` or `/permits/:id` href segment).
 */
export function resolveDepartmentForAgency(agency, departments) {
    const raw = (agency.departmentKey ?? '').trim();
    if (!raw)
        return null;
    const key = raw.toLowerCase();
    for (const d of departments) {
        const rid = (d.recordId ?? '').trim();
        if (rid && rid.toLowerCase() === key)
            return d;
        const seg = permitsPathSegment(d.href);
        if (seg && seg === key)
            return d;
    }
    return null;
}
